export const flagMap = {
    'United States': 'us',
    'Taiwan': 'tw',
    'Japan': 'jp',
    'Australia': 'au',
    'France': 'fr',
    'United Kingdom': 'gb',
    'Malaysia': 'my',
    'India': 'in',
    'Russia': 'ru',
    'South Korea': 'kr',
}